import { BodyGrey, BodyLarge } from '../Typography';
import { Box, Radio, styled } from '@mui/material';

export const Root = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'checked',
})<{
  checked?: boolean;
}>`
  border-radius: 5px;
  border: 1px solid ${(props) => (props.checked ? '#f16622' : '#A9A9A9')};
  padding: 24px;
  cursor: pointer;
  background-color: ${(props) => (props.checked ? 'rgba(241, 103, 34, 0.08)' : 'none')};
  position: relative;
`;

export const TitleContainer = styled(Box)`
  text-transform: capitalize;
  line-height: 20px;
`;

export const StyledBodyLarge = styled(BodyLarge)`
  margin-bottom: 0px;
  line-height: 20px;
  @media (max-width: 767px) {
    font-size: 16px;
  }
`;

export const StyledBodyGrey = styled(BodyGrey)`
  margin-bottom: 0px;
  line-height: 18px;
`;

export const StyledRadio = styled(Radio)`
  border-radius: 50%;
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 12px;
  box-sizing: border-box;
`;
